import {ReloadButton,} from '@flexinet/ui-components';
import {Box,} from '@mantine/core';
import {useQueryClient} from '@tanstack/react-query';
import {executionsKeys} from '../hooks/useExecutionsQuery';

export const ReloadRecordsButton = () => {
    const queryClient = useQueryClient();

    const handleReload = () => {
        queryClient.invalidateQueries({queryKey: executionsKeys.all});
    };

    return (
        <Box mx='s'>
            <ReloadButton onClick={handleReload}/>
        </Box>
    );
};
